import React, { HTMLAttributes } from 'react';

import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import {
  Container,
  Icon,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import classNames from 'classnames';

import { ParagraphQuote as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphQuoteProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphQuote: React.FC<ParagraphQuoteProps> = ({
  entity,
}) => {
  const paragraphQuote = entity.toJS();

  const writer = paragraphQuote.field_name[0].value;
  const quote = paragraphQuote.field_body[0].processed || '';
  const position = paragraphQuote.field_label[0]?.value;
  const profileImage = paragraphQuote.field_profile_picture[0];
  const largeMedia = paragraphQuote.field_media_item?.[0];

  const alignment = paragraphQuote.field_alignment?.[0]?.value;
  const containerClass = classNames('Paragraph', 'ParagraphQuote', {
    'ParagraphQuote--flipped': alignment === 'left',
  });

  const mediaClass = classNames('col-12 col-md-6 col-lg-5', {
    'offset-lg-1': ['right'].includes(alignment),
  });

  const bodyClass = classNames('col-12 col-md-6 col-lg-6 offset-lg-0', {
    'offset-lg-1': ['left'].includes(alignment),
    'col-md-10 offset-md-1 col-lg-8 offset-lg-2': !largeMedia,
  });

  return (
    <div className={containerClass}>
      <Container>
        <div className="row">

          <div className={bodyClass}>
            <div className="ParagraphQuote__body">
              <div className="ParagraphQuote__content">
                <Icon name="arrow_forward" flair="outlined" />
                <WysiwygField html={quote} />
                <div className="ParagraphQuote__writer">

                  {profileImage && (
                    <DynamicMediaItem
                      media={profileImage}
                    />
                  )}
                  <div className="ParagraphQuote__writerInfo">
                    <h4>{writer}</h4>
                    <span>{position}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {largeMedia && (
            <div className={mediaClass}>
              <DynamicMediaItem
                media={largeMedia}
                imageAspectRatio="1_1"
                className="ParagraphQuote__media"
              />
            </div>
          )}
        </div>

      </Container>
    </div>
  );
};

export default ParagraphQuote;
